import { NavigationProp, ParamListBase } from "@react-navigation/native";
import React from "react";
import { useSelector } from "react-redux";

import { RetailerSettings } from "src/components";
import RepProfile from "./RepProfile";
import BrandProfile from "./BrandProfile";

const P09_Profile: React.FC<{ navigation: NavigationProp<ParamListBase> }> = () => {
  const accountType = useSelector((state) => state.UserReducer.profile.accountType);

  if (accountType === "brand") {
    return <BrandProfile />;
  }

  if (accountType === "retailer") {
    return <RetailerSettings />;
  }

  return <RepProfile />;
};

export const P09 = React.memo(P09_Profile);
